var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{attrs:{"value":_vm.dialog,"title":_vm.$t('common.note_from_coach'),"width":400,"persistent":""},on:{"input":_vm.onDialogInput,"close":_vm.hide}},[_c('div',{staticClass:"note-message"},[_vm._v(_vm._s(_vm.message))]),_c('v-img',{staticClass:"ml-auto mt-4 img-logo",attrs:{"src":_vm.imgPlaceholder,"width":"30"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }